export const environment = {
  production: true,

  firebaseConfig: {
    apiKey: 'AIzaSyDczz7lOdIJsllrF3EGyH0_RR1FyGArp0k',
    authDomain: 'custom-black-directory.firebaseapp.com',
    projectId: 'custom-black-directory',
    storageBucket: 'custom-black-directory.appspot.com',
    messagingSenderId: '630525649380',
    appId: '1:630525649380:web:53e52a5fc39dd5e8e1e7f1',
    measurementId: 'G-TQX7242629',
    databaseURL: 'https://custom-black-directory-default-rtdb.firebaseio.com/'
  }
};
